import {
  ApplicationConfig,
  inject,
  provideBrowserGlobalErrorListeners,
  provideAppInitializer,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';

import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalService,
} from '@azure/msal-angular';
import {
  msalGuardConfigFactory,
  msalInstanceFactory,
  msalInterceptorConfigFactory,
} from './core/auth/auth.config';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { authTokenInterceptor } from './core/auth/auth-token.interceptor';
import { retryInterceptor } from './shared/interceptors/retry.interceptor';
import { errorInterceptor } from './shared/interceptors/error.interceptor';
import { tablerIconsProvider } from './shared/providers/tabler-icons.provider';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { firstValueFrom } from 'rxjs';
import { provideToastr } from 'ngx-toastr';
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideAnimationsAsync(),
    provideLottieOptions({
      player: () => player,
    }),
    provideHttpClient(
      withFetch(),
      withInterceptors([authTokenInterceptor, errorInterceptor, retryInterceptor]),
    ),
    provideRouter(routes),
    provideAppInitializer(() => {
      const msalService = inject(MsalService);
      return firstValueFrom(msalService.initialize());
    }),
    { provide: MSAL_INSTANCE, useFactory: msalInstanceFactory },
    { provide: MSAL_GUARD_CONFIG, useFactory: msalGuardConfigFactory },
    { provide: MSAL_INTERCEPTOR_CONFIG, useFactory: msalInterceptorConfigFactory },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    tablerIconsProvider,
    provideToastr({
      positionClass: 'toast-bottom-center',
      timeOut: 3000,
      preventDuplicates: true,
      closeButton: true,
      // progressBar: true,
    }),
  ],
};
